export default "__VITE_ASSET__05b9eba9__"